import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const getShadeNumberList = createAsyncThunk("/getShadeList", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}shade/api/v1/getShadeList`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(" response", response);
    return response; 
  } catch (error) {
    console.error("Error fetching Shades", error);

    return rejectWithValue(error.response?.data?.message || "Failed to fetch Shades");
  }
});
